<script>
  import GlyphButton from "./GlyphButton.svelte"

  export let glyphGroups
  export let selected
</script>

<div class="root">
  {#each Object.entries(glyphGroups) as [group, glyphs]}
    <div class="group">
      <h2>{group}</h2>
      <div class="glyphs">
        {#each glyphs as glyph}
          <div class="glyph">
            <GlyphButton on:click {glyph} selected={glyph === selected} />
          </div>
        {/each}
      </div>
    </div>
  {/each}
</div>

<style>
  .root {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-m);
  }

  .glyphs {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: auto;
    gap: 1px;

    font-size: 1.5em;
    line-height: 1em;
    margin-left: 1px;
    margin-right: 1px;
    margin-bottom: 1px;
  }

  .group {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacing-m) / 2);
  }

  .glyph {
    outline: 1px solid currentColor;
  }

  @media (min-width: 800px) {
    .glyphs {
      grid-template-columns: repeat(8, 1fr);
    }
  }

  @media (min-width: 1000px) {
    .glyphs {
      grid-template-columns: repeat(10, 1fr);
    }
  }

  @media (min-width: 1200px) {
    .glyphs {
      grid-template-columns: repeat(12, 1fr);
    }
  }
</style>
